var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticStyle: { "margin-bottom": "15px" } }, [
        _c("span", { staticClass: "common-title" }, [_vm._v("审批记录")]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "text-color-blue pointer right-oper",
            on: {
              click: function($event) {
                _vm.showMore = !_vm.showMore
              }
            }
          },
          [
            _vm._v(
              "\n      " + _vm._s(_vm.showMore ? "收起" : "展开") + "\n      "
            ),
            _c("a-icon", {
              staticStyle: { "font-size": "12px" },
              attrs: { type: _vm.showMore ? "up" : "down" }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.showMore && _vm.pageData.length > 0
        ? _c("a-table", {
            attrs: {
              size: "middle",
              columns: _vm.columns,
              "row-key": function(record, index) {
                return record.id + "_" + index
              },
              "data-source": _vm.pageData,
              bordered: "",
              scroll: {},
              locale: { emptyText: "暂无数据" }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "approveTime",
                  fn: function(text) {
                    return [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm._f("dateFormat")(text, "YYYY-mm-dd HH:MM:SS")
                          ) +
                          "\n    "
                      )
                    ]
                  }
                }
              ],
              null,
              false,
              2659448420
            )
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.showMore || _vm.pageData.length == 0
        ? _c("table", { staticClass: "table-common" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("tbody", [
              !_vm.showMore
                ? _c("tr", [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "text-align": "center",
                          color: "#999",
                          "font-size": "18px"
                        },
                        attrs: { colspan: "8" }
                      },
                      [_vm._v("\n          ···\n        ")]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showMore && _vm.pageData.length == 0
                ? _c("tr", [
                    _c(
                      "td",
                      {
                        staticStyle: { "text-align": "center" },
                        attrs: { colspan: "8" }
                      },
                      [_vm._v("暂无数据")]
                    )
                  ])
                : _vm._e()
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("业务节点")]),
        _vm._v(" "),
        _c("th", [_vm._v("提交/审批人")]),
        _vm._v(" "),
        _c("th", [_vm._v("提交/审批结果")]),
        _vm._v(" "),
        _c("th", [_vm._v("审批意见")]),
        _vm._v(" "),
        _c("th", [_vm._v("操作时间")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30c5e412", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30c5e412","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gold-page/gold-detail-approve-history.vue
// module id = iBoG
// module chunks = 1